import { dictadoLogic } from './dictado.logic';
import { DictadoHost, DictadoProjector, DictadoStudent } from '../eval-blocks/DictadoAnatomiaViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const dictadoPlugin: ActivityPlugin<'dictado'> = {
  ...dictadoLogic,
  displayName: GAME_MODE_CATALOG.dictado.displayName,
  icon: GAME_MODE_CATALOG.dictado.icon,
  HostView: DictadoHost,
  StudentView: DictadoStudent,
  ProjectorView: DictadoProjector,
};

export { demoDictadoPayload } from './dictado.logic';
